import { isArray } from 'lodash';

import asArray from 'utils/arrays/asArray.util';
import asObject from 'utils/objects/asObject.util';

const compileObject = (object, item) => {
  const id = item?.id;
  object[id] = item;
  return object;
};

const reduceStylists = (state, action) => {
  const { json: data } = action ?? {};

  const isValidData = isArray(data);

  const stylistsList = isValidData ? data : asArray();
  const stylistsMap = isValidData ? data.reduce(compileObject, {}) : asObject();

  return { ...state, stylistsList, stylistsMap };
};

export default reduceStylists;
